import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { CheckCircle2 } from "lucide-react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export default function CheckoutReturn() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    // small delay so the user sees the success state before any redirect
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Helmet>
        <title>Payment Complete | RunoBlog</title>
      </Helmet>
      <Navigation />
      <section className="flex-1 container mx-auto px-4 py-16 max-w-xl">
        <Card className="p-8 text-center">
          <CheckCircle2 className="h-16 w-16 text-primary mx-auto mb-4" />
          <h1 className="text-2xl font-bold mb-2">Payment complete</h1>
          <p className="text-muted-foreground mb-6">
            Your purchase has been recorded. Access will appear automatically — refresh
            the original page if it doesn't show up within a few seconds.
          </p>
          {sessionId && (
            <p className="text-xs text-muted-foreground mb-6 font-mono break-all">
              Reference: {sessionId}
            </p>
          )}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild>
              <Link to="/my-learning">Go to My Learning</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/">Back to home</Link>
            </Button>
          </div>
        </Card>
      </section>
      <Footer />
    </div>
  );
}
